import React, { Component, Fragment }  from "react";
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';
import { DEFAULT_AVATAR, getPublicAssetUrl } from "../../helpers/Utils";

class SingleLightbox extends Component {

    constructor(props) {
        super(props);
        this.onThumbClick = this.onThumbClick.bind(this);
        this.onThumbError = this.onThumbError.bind(this);
        this.state = {
            photoIndex: 0,
            isOpen: false,
        };
      }

      onThumbClick(event) {
        if (event) event.preventDefault();
        this.setState({ isOpen: true });
      }

    onThumbError(event) {
        const fallback = getPublicAssetUrl(this.props.fallback || DEFAULT_AVATAR);
        const target = event && event.target;

        if (target && !target.dataset.fallbackApplied) {
            target.dataset.fallbackApplied = "true";
            target.src = fallback;
        }
    }


    render() {
        const { isOpen } = this.state;
        return (
            <Fragment>
                <button
                    type="button"
                    className="border-0 bg-transparent p-0"
                    onClick={this.onThumbClick}
                    aria-label="Xem ảnh"
                >
                    <img
                        src={this.props.thumb}
                        alt="thumbnail"
                        className={this.props.className}
                        onError={this.onThumbError}
                        crossOrigin={this.props.crossOrigin}
                    />
                </button>

                {isOpen && (
                    <Lightbox
                        mainSrc={this.props.large}
                        onCloseRequest={() => this.setState({ isOpen: false })}
                    />
                )}
            </Fragment>
        );
    }
}

export default SingleLightbox;
